import './Accordion.css';
import Place from '../../../dist/assets/Place.png';
import Time from '../../../dist/assets/Time.png';
import DateIcon from '../../../dist/assets/Date.png';
import Info from '../../../dist/assets/Info.png';
import Comments from '../../../dist/assets/Comments.png';
import  {useEffect } from 'react';

const AccordionEventItem =(props) =>{
    const _Months = ["ינו'", "פבר'", "מרץ", "אפר'", "מאי", "יוני", "יולי", "אוג'", "ספט'", "אוק'", "נוב'", "דצמ'"];
    let text1 = props.data.FaqRichText1 ? <div className="text1" dangerouslySetInnerHTML={{__html: props.data.FaqRichText1 }}/> : null;

    useEffect(()=>{
        addEventListener("keydown",props.handleUserKeypress);
        return()=>{
            removeEventListener("keydown",props.handleUserKeypress);
        }
    },[]);
    
     
    let eventDate = new Date(props.data.MODNewsPublishDate);
    let dayInMonth = <div className='dayInMonth'>{eventDate.getDate()}</div>
    let month = <div className='Month'>{_Months[eventDate.getMonth()]}</div>
    let isEvent = (props.openItem == props.data.ID);
    return (
        <div className={'accordion-item modCard ' +  (isEvent ? 'open' : '')} id={"wrap_" + props.WpId +"_"+ props.data.ID} key={"AccordionCategory_"+ + props.WpId +"_"+ props.data.ID}>
        <div className="title modCard-header" id={"accHead_" + props.WpId +"_"+ props.index} >
          <h2 className="mb-0">
          <a role="button" className={"btn btn-link "+(props.isOpen  ? "" : "collapsed")}  data-toggle="collapse" data-target={"#accColapse_" + props.WpId +"_"+ props.index} 
                aria-expanded="true" aria-controls={"accColapse_" + props.WpId +"_"+ props.index} >
                    {/* onClick={e => props.toggleItem(e)} {props.isOpen || isEvent  ? '-' : '+'} */}
              <span className="fa openclose" aria-hidden="true"></span>
              <div className="itemTitle">
                <div className="eventDate">{dayInMonth}{month}</div>
                <div className="titleHour">
                    <div className="title">{props.data.Title}</div>
                    <div className="hour">{props.data.ModHour} </div>
                </div>
              </div>
            </a>
             
          </h2> 
        </div>
        <div id={"accColapse_" + props.WpId +"_"+ props.index} className= {(isEvent ? "collapse show" : 'collapse')} aria-labelledby={"accHead" + props.WpId +"_"+ props.index} 
            data-parent={"accordion_" + props.WpId }>
            <div className="modCard-body" > 
                <div className="eventDetailsItem">
                 <div>
                    <img src={DateIcon} alt="תמונת תאריך"/>
                    <h3>תאריך הטקס</h3>
                   </div>
                    <p>{ moment(eventDate).locale('he-il').format('יום dddd, D [ב]MMMM YYYY') + (props.data.MODNewsPublishDate_Heb ? ", "+ props.data.MODNewsPublishDate_Heb : "")}.</p>
                </div>
                <div className="eventDetailsItem">
                    <div>
                     <img src={Time} alt=""/>
                     <h3>שעת הטקס</h3>
                    </div>
                   
                    <p>{props.data.ModHour}</p>
                </div>
                <div className="eventDetailsItem">
                    <div>
                        <img src={Place} alt=""/>
                        <h3>מיקום הטקס</h3>
                    </div>
                    <p>{props.data.ModLocation}</p> 
                    {props.data.ModLinksLink &&
                    <div className={props.data.ModLinksLink ? "wazeLink" : "d-none"}>
                        <a href={props.data.ModLinksLink.NavigateUrl}>נווט ליעד</a>
                    </div>
                    }
                </div>
                <div className="eventDetailsItem">
                     <div>
                        <img src={Info} alt=""/>
                        <h3>מידע נוסף</h3>
                    </div> 
                    <p dangerouslySetInnerHTML={{__html: props.data.FormContent }}></p>
                </div> 
                <div className="eventDetailsItem">  
                    <div>
                        <img src={Comments} alt=""/>
                        <h3>לבירור פרטים</h3>
                    </div>
                    <p dangerouslySetInnerHTML={{__html: props.data.FaqRichText1 }}></p>
                    <div className={props.data.attachment_url ? "invitation linkFormDiv" : "d-none"}>
                        <a href={props.data.attachment_url}>הזמנה להורדה</a>
                    </div>
                </div>
            </div>
        </div>
      </div>
    );
}


export default AccordionEventItem;